import { Link } from 'react-router'
import { Logo } from '@/components/brand/logo'
import { onDarkActionClass } from '@/components/shared/styles'
import { useDocumentTitle } from '@/hooks/use-document-title'
import { cn } from '@/lib/utils'

interface ErrorScreenProps {
  code: number
  title: string
  message: string
  to: string
  action: string
}

/** The website's not-found page: the painted hero box, inset from the viewport. */
export function ErrorScreen({ code, title, message, to, action }: ErrorScreenProps) {
  useDocumentTitle(code === 404 ? 'Page not found' : 'Something went wrong')
  return (
    <div className="min-h-svh bg-background p-2 sm:p-3">
      <main className="herobox flex min-h-[calc(100svh-16px)] flex-col rounded-3xl px-6 py-7 sm:min-h-[calc(100svh-24px)] sm:rounded-4xl sm:px-12 sm:py-10">
        <Logo onDark className="h-8 self-start" />
        <div className="my-auto max-w-2xl py-16">
          <p className="font-mono text-feature font-semibold text-[rgb(234_242_249/0.72)]">{code}</p>
          <h1 className="mt-3 text-feature font-extrabold text-balance text-white sm:text-display">{title}</h1>
          <p className="mt-4 max-w-[52ch] text-lede wrap-anywhere text-[rgb(234_242_249/0.86)]">{message}</p>
          {/* A link, styled: Base UI's Button wants a native <button> underneath. */}
          <Link
            to={to}
            className={cn(
              onDarkActionClass,
              'mt-8 inline-flex items-center justify-center hover:no-underline focus-visible:outline-white',
            )}
          >
            {action}
          </Link>
        </div>
      </main>
    </div>
  )
}
